import AppMagma from '../app-magma'

export default
{
    components:
    {
        AppMagma
    },

    props:
    {
        content: { type: Array, default: null }
    },

    created()
    {
        this.eventHub.$on('window:resize', this.onResize)
    },

    destroyed()
    {
        this.eventHub.$off('window:resize', this.onResize)
    },

    methods:
    {
        onPageReady()
        {
            this.$emit('page:ready')
        },

        onResize()
        {
            if(!this.$root.isTouch && !this.$root.isModalPostActive)
            {
                window.location.reload()
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-page-home/script.js